// Shared RBAC role constants mirrored from the DMS backend.
// Order is highest -> lowest privilege.

export const ROLES = {
  SUPER_ADMIN: "superAdmin",
  HARDWARE_ADMIN: "hardwareAdmin",
  SUPERVISOR: "supervisor",
  TECHNICIAN: "technician",
};

// Rank: higher number == higher privilege. Mirrors backend rank checks.
export const ROLE_RANK = {
  [ROLES.SUPER_ADMIN]: 4,
  [ROLES.HARDWARE_ADMIN]: 3,
  [ROLES.SUPERVISOR]: 2,
  [ROLES.TECHNICIAN]: 1,
};

// Ordered highest -> lowest for selects/filters.
export const ROLE_OPTIONS = [
  { value: ROLES.SUPER_ADMIN, label: "Super Admin" },
  { value: ROLES.HARDWARE_ADMIN, label: "Hardware Admin" },
  { value: ROLES.SUPERVISOR, label: "Supervisor" },
  { value: ROLES.TECHNICIAN, label: "Technician" },
];

// Tag colors for readable role badges in the Users table.
export const ROLE_TAG_COLOR = {
  [ROLES.SUPER_ADMIN]: "red",
  [ROLES.HARDWARE_ADMIN]: "volcano",
  [ROLES.SUPERVISOR]: "blue",
  [ROLES.TECHNICIAN]: "green",
};

export const ROLE_LABEL = {
  [ROLES.SUPER_ADMIN]: "Super Admin",
  [ROLES.HARDWARE_ADMIN]: "Hardware Admin",
  [ROLES.SUPERVISOR]: "Supervisor",
  [ROLES.TECHNICIAN]: "Technician",
};

// Helpers mirroring backend authorization rules.
export const rankOf = (role) => ROLE_RANK[role] || 0;

// hardwareAdmin and above may access user management.
export const canManageUsers = (role) => rankOf(role) >= ROLE_RANK[ROLES.HARDWARE_ADMIN];

// Only superAdmin may delete users.
export const canDeleteUsers = (role) => rankOf(role) === ROLE_RANK[ROLES.SUPER_ADMIN];
